import { Breakpoints, styled, ThemeDefinition } from '@vw-marketing/us-components';

interface StyledVehicleSectionProps {
  activeCTA: boolean;
  ciGuidelinesRollout: boolean;
  isSwitchCtaAvailable: boolean;
  theme: ThemeDefinition;
}

export const StyledVehicleSection = styled.div<StyledVehicleSectionProps>`
  ${({ activeCTA, ciGuidelinesRollout, isSwitchCtaAvailable, theme }: StyledVehicleSectionProps) => {
    return `
      @media (min-width: ${Breakpoints.b560}px) {
        align-items: center;
        background: ${ciGuidelinesRollout ? theme.colors.background.highlight : theme.colors.background.tertiary};
        display: flex;
        gap: ${theme.size.static510};
        justify-content: center;
        margin-left: -8vw;
        margin-right: -8vw;
        padding: ${theme.size.static400} 80px;

        @media (min-width: ${Breakpoints.b960}px) {
          margin: 0px;
        }

        @media (min-width: ${Breakpoints.b1280}px) {
          margin-left: -48px;
          margin-right: -48px;
          margin-bottom: ${!activeCTA && !isSwitchCtaAvailable ? '-48px' : '0'};
        }

        @media (min-width: ${Breakpoints.b1600}px) {
          padding: ${theme.size.static400} ${theme.size.static510};
        }
      `;
    }}
  }
`;

